import React, { useEffect, useState, useRef } from 'react';
import { openEyeIcon, splitterIcon } from '../AppIcons';
import BookmarkHandler from "./BookmarkHandler.tsx"
import ShowHistoryHandler from "./ShowHistoryHandler";
import EditIcr from "./EditIcr.tsx";
import LineByLine from './LineByLine';
import { Navigate, useParams } from "react-router-dom";
import axiosInstance from '../services/axiosInstance';
import APIUrls from '../services/APIUrls';
import SubmitButtonPopup from './SubmitButtonPopup';
import jQuery from "jquery";
import axios from 'axios';
import $ from "jquery";
import { useNavigate } from 'react-router-dom';
import SuccessNotification from './SuccessNotification';



//projectAssetFileId is considered as projectId
function IcrPreview() {
    const navigate = useNavigate();
    sessionStorage.setItem("cached_url", window.location.pathname);
    const parentHttpDomain = process.env.REACT_APP_BACKEND_SERVER;
    const param = useParams();
    const sourceIframeRef = useRef();
    const targetIframeRef = useRef();
    const [loading, setLoading] = useState(true);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const [isLineByLineActive, setIsLineByLineActive] = useState(false);
    const [sourcePreviewToggleButtonText, setSourcePreviewToggleButtonText] = useState("Hide Source Preview");
    const projectId = param.id;
    const iframeSrc = `${parentHttpDomain}/preview/${projectId}/source`;
    const iframeTarget = `${parentHttpDomain}/preview/${projectId}/target`;
    const [editedTusCount, setEditedTusCount] = useState(0);
    const [feedbackCount, setFeedbackCount] = useState(0); 
    const [leveragedTuCount, setLeveragedTuCount] = useState(0); 
    const [lockedTuCount, setLockedTuCount] = useState(0); 
    const [aipeTuCount, setAipeTuCount] = useState(0); 
    const [isReviewCompleted, setIsReviewCompleted] = useState(false);
    const [isFinalPreviewChecked, setIsFinalPreviewChecked] = useState(false);
    const targetAssetMetaData = useRef();
    const [popUpValue, setPopUpValue] = useState(false);
    const [isXLIFFOnly, setIsXLIFFOnly] = useState(false); // Track XLIFF-only status
    const [feedbackCategories, setFeedbackCategories] = useState([]);
    const [feedbackSeverities, setFeedbackSeverities] = useState([]);
    const [showSuccessNotification, setShowSuccessNotification] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [currentUserEmail, setCurrentUserEmail] = useState('');
    const [isAssignee, setIsAssignee] = useState(false);

    const [activeFilter, setActiveFilter] = useState(null);
    const [isLoadingFilter, setIsLoadingFilter] = useState(false);
    const validateAccess = async () => {
        try {
            const { data } = await axiosInstance.get(APIUrls.ASSET_ACCESS_CHECK(projectId));
            if (!data) {
                navigate('/access/denied');
                return false;
            }
            return true;
        } catch (error) {
            navigate('/access/denied');
            return false;
        }
    };

    const handleEditedTusCountUpdate = (newCount) => {
        setEditedTusCount(newCount);
    };
    

    const handleFeedbackCountUpdate = (newCount) => { 
        setFeedbackCount(newCount);
    };


    const handleReviewStatus = (reviewStatus) => {
        setIsReviewCompleted(reviewStatus);
    };

    const getCurrentUserEmailFromToken = () => {
        try {
            const token = sessionStorage.getItem('access_token');
            if (!token) {
                console.warn('No access token found in session storage');
                return '';
            }

            // Decode the JWT token to get the payload
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            const decodedToken = JSON.parse(jsonPayload);

            // The user email is in the 'sub' field (subject claim)
            const userEmail = decodedToken.sub;
            

            return userEmail;
        } catch (error) {
            console.error('Error decoding JWT token:', error);
            return '';
        }
    };

    
    const fetchFeedbackOptions = async () => {
        try {
            const [categoriesResponse, severitiesResponse] = await Promise.all([
                axiosInstance.get(APIUrls.GET_FEEDBACK_CATEGORIES()),
                axiosInstance.get(APIUrls.GET_FEEDBACK_SEVERITIES())
            ]);
            
            setFeedbackCategories(categoriesResponse.data.body || []);
            setFeedbackSeverities(severitiesResponse.data.body || []);
        } catch (error) {
            console.error('Error fetching feedback options:', error);
        }
    };

    const fetchFeedbackCount = async () => { 
        try {
            const response = await axiosInstance.get(APIUrls.FEEDBACK_TRANSLATION_UNITS_COUNT(projectId));
            setFeedbackCount(response.data.COMMENTED || 0);
        } catch (err) {
            console.error('Error fetching feedback count:', err);
        }
    };

    const fetchLeveragedCount = async () => { 
        try {
            const response = await axiosInstance.get(APIUrls.LEVERAGED_TRANSLATION_UNITS_COUNT(projectId));
            setLeveragedTuCount(response.data.LEVERAGED || 0);
        } catch (err) {
            console.error('Error fetching feedback count:', err);
        }
    };

    const fetchLockedCount = async () => { 
        try {
            const response = await axiosInstance.get(APIUrls.LOCKED_TRANSLATION_UNITS_COUNT(projectId));
            setLockedTuCount(response.data.LOCKED || 0);
        } catch (err) {
            console.error('Error fetching feedback count:', err);
        }
    };

    const fetchAipeCount = async () => { 
        try {
            const response = await axiosInstance.get(APIUrls.AIPE_TRANSLATION_UNITS_COUNT(projectId));
            setAipeTuCount(response.data.AIQE || 0);
        } catch (err) {
            console.error('Error fetching feedback count:', err);
        }
    };

    
    const formatCategoryType = (type) => {
        if (!type) return '';
        return type
        .toLowerCase()          
        .replace(/_/g, ' ')     
        .replace(/\b\w/g, l => l.toUpperCase()) 
        .trim();  
    };

    const formatCategoryName = (name) => {
        if (!name) return '';
        return name.toLowerCase().replace(/_/g, ' ')
            .replace(/\b\w/g, l => l.toUpperCase())
            .replace(/3rd Party/g, '3rd Party');
    };

    
    const handleFeedbackSubmit = async (payload, docSegPos) => {
        try {
            const response = await axiosInstance.post(
                APIUrls.SUBMIT_FEEDBACK(projectId, docSegPos),
                payload
            );
            setFeedbackCount(response.data.feedbackCount || feedbackCount + 1);
            // Show success notification
            setNotificationMessage('Feedback submitted successfully');
            setShowSuccessNotification(true);
            
            if (activeFilter === "COMMENTED") { 
                highlightFilteredTus("COMMENTED");
            }
            return response.data; 
        } catch (error) {
            console.error('Error submitting feedback:', error);
            throw error; 
        }
    };

    useEffect(() => {
        if (!isLineByLineActive && activeFilter) {
            highlightFilteredTus(activeFilter);
        }
    }, [isLineByLineActive, activeFilter]);

    async function showPreview() {
        if (!(await validateAccess())) return;
        document.getElementById("preview-btn")?.classList.add("active");
        document.getElementById("preview-content")?.classList.remove("hide");
        document.querySelector(".zoom.flex-center")?.classList.remove("hide");
        document.getElementById("line-by-line")?.classList.remove("active");
        document.getElementById("line-by-line-view-content")?.classList.add("hide");
        document.getElementById("final-preview-checkbox")?.classList.remove("hide");
        setIsLineByLineActive(false);
        if (activeFilter) {
            highlightFilteredTus(activeFilter);
        }
    }

    async function showLineByLineView() {
        if (!(await validateAccess())) return;
        document.getElementById("preview-btn")?.classList.remove("active");
        document.getElementById("preview-content")?.classList.add("hide");
        document.querySelector(".zoom.flex-center")?.classList.add("hide");
        document.getElementById("line-by-line")?.classList.add("active");
        document.getElementById("line-by-line-view-content")?.classList.remove("hide");
        document.getElementById("final-preview-checkbox")?.classList.add("hide");
        setIsLineByLineActive(true);
    }

    useEffect(() => {
        if (isXLIFFOnly) {
            showLineByLineView();
        }
    }, [isXLIFFOnly]);

    useEffect(() => {
        const permissionCheck = async () => {
            const allowedToAccess = await axiosInstance.get(APIUrls.ASSET_ACCESS_CHECK(projectId));
            if (!allowedToAccess.data) {
                navigate('/access/denied');
            }
        };

        const fetchProjectDetails = async () => {
            try {
                const projectDetailsResponse = await axiosInstance.get(APIUrls.GET_PROJECT_ASSET_DETAILS_BY_ID(projectId));
                targetAssetMetaData.current = projectDetailsResponse?.data;
                setIsReviewCompleted(projectDetailsResponse?.data?.reviewCompleted);
                setIsXLIFFOnly(projectDetailsResponse?.data?.assetType === 'XLIFF');
                const userEmail = (getCurrentUserEmailFromToken() || '').trim().toLowerCase();
                const acl = projectDetailsResponse?.data?.accessControlList || [];

                const found = acl.find(a => {
                    const aclEmail = (a?.email || '').trim().toLowerCase();
                    const activeFlag = (a?.isActive === true) || (a?.active === true);
                    return aclEmail === userEmail && activeFlag;
                });

                setIsAssignee(!!(found && String(found.role).toUpperCase() === 'ROLE_ASSIGNEE'));
            } catch (err) {
                console.error("Error fetching project details:", err);
            }
        };

        const fetchEditedTusCount = async () => {
            try {
                const editedTusCountResponse = await axiosInstance.get(APIUrls.EDITED_TRANSLATION_UNITS_COUNT(projectId));
                handleEditedTusCountUpdate(editedTusCountResponse.data);
            } catch (err) {
                console.error("Error fetching edited TUs count:", err);
            }
        };

        const userEmail = getCurrentUserEmailFromToken();
        setCurrentUserEmail(userEmail);

        fetchProjectDetails();
        fetchEditedTusCount();
        permissionCheck();
        fetchFeedbackOptions();
        fetchFeedbackCount(); 
        fetchAipeCount();
        fetchLockedCount();
        fetchLeveragedCount();

    }, []);

    

    useEffect(() => {
        const loadContent = async () => {
            try {
                setLoading(true);
                const sourceResponse = await axios.get(iframeSrc, {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('access_token')}` }
                });
                const targetResponse = await axios.get(iframeTarget, {
                    headers: { Authorization: `Bearer ${sessionStorage.getItem('access_token')}` }
                });

                const waitForIframe = (iframe) => {
                    return new Promise((resolve) => {
                        const check = () => {
                            if (iframe.current?.contentWindow) {
                                resolve();
                            } else {
                                setTimeout(check, 50);
                            }
                        };
                        check();
                    });
                };

                await Promise.all([waitForIframe(sourceIframeRef), waitForIframe(targetIframeRef)]);                
                setIframeContent(document.getElementById('source-preview'), sourceResponse.data);
                setIframeContent(document.getElementById('target-preview'), targetResponse.data);
            } catch (error) {
                console.error('Error loading iframe content:', error);
            } finally {
                setLoading(false);
            }
        };
        loadContent();
    }, [iframeSrc, iframeTarget]);

    function setIframeContent(iframe, content) {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.write(content);
        doc.close();
    }

    function onLoadIFrame() {
        setIframeLoaded(true);
    }

    useEffect(() => {
        if (iframeLoaded) {
            setIframeLoaded(false);
        }
    }, [iframeLoaded]);

    useEffect(() => {
        if (isLineByLineActive) {
            setIsLineByLineActive(false);
        }
    }, [isLineByLineActive]);

    function showLineByLineEditTus(button) {
        if (button) {
            setActiveFilter("EDITED");
            highlightFilteredTus("EDITED");
        } else {
            setActiveFilter(null);
            removeHighlightedTus("EDITED");
        }
    }

    function fetchFilteredTUs(selectedFilter) {
        if (isLoadingFilter) return; // Prevent multiple clicks while loading

        if (activeFilter === selectedFilter) {
            setActiveFilter(null);
            removeHighlightedTus(selectedFilter);
        } else {
            if (activeFilter) {
                removeHighlightedTus(activeFilter);
            }
            setActiveFilter(selectedFilter);
            highlightFilteredTus(selectedFilter);
        }
    }

    function highlightFilteredTus(selectedFilter) {
        setIsLoadingFilter(true);
        fetchData(selectedFilter)
            .then((data) => {
                const postData = {
                    data: data,
                    action: "HIGHLIGHT_FILTERED_TUS",
                    selectedFilter: selectedFilter
                };
                document.getElementById('target-preview')?.contentWindow
                    .postMessage(JSON.stringify(postData), '*');
            })
            .finally(() => {
                setIsLoadingFilter(false);
            });
    }

    function removeHighlightedTus(selectedFilter) {
        const postData = {
            action: "REMOVE_HIGHLIGHT_FILTERED_TUS",
            selectedFilter: selectedFilter
        };
        document.getElementById('target-preview')?.contentWindow
            .postMessage(JSON.stringify(postData), '*');
    }

    function fetchData(selectedFilter, pageNumber = 1, accumulatedData = []) {           
       let endpoint;
        switch (selectedFilter) {
        case "COMMENTED":
            endpoint = APIUrls.FEEDBACK_TRANSLATION_UNITS(projectId, pageNumber);
            break;
        case "TM":
            endpoint = APIUrls.LEVERAGED_TRANSLATION_UNITS(projectId, pageNumber);
            break;
        case "LOCKED":
            endpoint = APIUrls.LOCKED_TRANSLATION_UNITS(projectId, pageNumber);
            break;
        case "AIPE":
            endpoint = APIUrls.AIQE_TRANSLATION_UNITS(projectId, pageNumber);
            break;    
        default:
            endpoint = APIUrls.PROJECT_TRANSLATED_FILE_TRANSLATION_UNITS(projectId, pageNumber, selectedFilter);
            break;
        }
            

        return axiosInstance.get(endpoint)
            .then((res) => {
                const newData = res?.data || [];
                const combinedData = [...accumulatedData, ...newData];

                // For COMMENTED filter, we don't need pagination
                if (selectedFilter === "COMMENTED") {
                    
                    return combinedData;
                }

                // For other filters, check if we have all data
                const totalCount = res.headers['x-total-count'] || newData.length;
                if (combinedData.length < totalCount && newData.length > 0) {
                    return fetchData(selectedFilter, pageNumber + 1, combinedData);
                } else {
                    
                    return combinedData;
                }
            })
            .catch(err => {
                console.error('Error fetching TUs:', err);
                
                return [];
            });
    }

    function toggleSourceViewHideAndShow() {
        if (jQuery(".icr-content-inner-right").hasClass("w-d100")) {
            jQuery(".icr-content-inner-left").removeClass("w-d0");
            jQuery(".icr-content-inner-right").removeClass("w-d100");
            setSourcePreviewToggleButtonText("Hide Source Preview");
            jQuery(".hide-show button").attr('aria-label', 'Hide Source Preview');
            jQuery(".splitter").removeClass("hide");
        } else {
            jQuery(".icr-content-inner-left").addClass("w-d0");
            jQuery(".icr-content-inner-right").addClass("w-d100");
            setSourcePreviewToggleButtonText("Show Source Preview");
            jQuery(".hide-show button").attr('aria-label', 'Show Source Preview');
            jQuery(".splitter").addClass("hide");
        }
    }

    jQuery("#final-preview").on("click", function () {
        let isChecked = jQuery(this).is(':checked');
        setIsFinalPreviewChecked(isChecked);
        if (isChecked) {
            setActiveFilter(null);
            document.getElementById('target-preview')?.contentWindow
                .postMessage(JSON.stringify({
                    action: "SHOW_FINAL_PREVIEW"
                }), '*');
        }
    });

    async function onSubmitClick() {
        if (!(await validateAccess())) return;
        setPopUpValue(true);
    }

    useEffect(() => {
        if (popUpValue) {
            jQuery("body").addClass("modal-open-10");
        } else {
            jQuery("body").removeClass("modal-open-10");
        }
    }, [popUpValue]);

    useEffect(() => {
        const handleMessage = (event) => {
            var message = {};
            try {
                message = JSON.parse(event.data);
            } catch (ex) {
                console.log("exception::", ex);
            }
            
            
        if (message.action === 'SUBMIT_FEEDBACK') {
            // Handle feedback submission from iframe
            handleFeedbackSubmit(message.payload, message.docSegPos);
        }
        else if (message.action === 'GET_FEEDBACK_CATEGORIES') {
            // Send FORMATTED categories to iframe
            const iframe = document.getElementById('target-preview');
            if (iframe && iframe.contentWindow) {
                // Format categories before sending
                const formattedCategories = feedbackCategories.map(cat => ({
                    ...cat,
                    fullDisplay: (cat.errorCategory?.display || formatCategoryType(cat.errorCategory?.name)) +
                        ': ' +
                        (cat.display || formatCategoryName(cat.name))
                }));

                iframe.contentWindow.postMessage(JSON.stringify({
                    action: "GET_FEEDBACK_CATEGORIES_RESPONSE",
                    data: formattedCategories
                }), window.location.origin);
            }
        }
        else if (message.action === 'GET_FEEDBACK_SEVERITIES') {
            // Send severities to iframe
            const iframe = document.getElementById('target-preview');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(JSON.stringify({
                    action: "GET_FEEDBACK_SEVERITIES_RESPONSE",
                    data: feedbackSeverities
                }), window.location.origin);
            }
        }
        else if (message.action === 'GET_FEEDBACK_COUNT') { 
            fetchFeedbackCount().then(() => {
                document.getElementById('target-preview')?.contentWindow
                    .postMessage(JSON.stringify({
                        action: "FEEDBACK_COUNT_RESPONSE",
                        data: { COMMENTED: feedbackCount }
                    }), '*');
            });
        }
        else if (message.action === 'UPDATE_FEEDBACK_COUNT') { 
            setFeedbackCount(message.count);
        }
        else if (message.action === 'SET_ACTIVE_FILTER') {
            setActiveFilter(message.filter);
        }
        else if (message.action === 'HIGHLIGHT_FILTERED_TUS') {
            setActiveFilter(message.selectedFilter);
            
        }
        else if (message.action === 'REMOVE_HIGHLIGHT_FILTERED_TUS') {
            if (activeFilter === message.selectedFilter) {
                setActiveFilter(null);
            }
            removeHighlightedTus(message.selectedFilter);
        }
        else if (message.action === "UPDATE_FEEDBACK_HIGHLIGHT") {
            // Update specific TU highlight
            const iframe = document.getElementById('target-preview');
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage(JSON.stringify({
                    action: "UPDATE_SINGLE_TU_HIGHLIGHT",
                    docSegPos: message.docSegPos,
                    hasFeedback: message.hasFeedback
                }), '*');
            }

            // Update feedback count
            if (message.feedbackCount !== undefined) {
                setFeedbackCount(message.feedbackCount);
            }
        }
        else if (message.action === "REFRESH_FILTERED_TUS") {
            // Refresh the filtered TUs list
            if (activeFilter === "COMMENTED") {
                highlightFilteredTus("COMMENTED");
            }
        }
        else if (message.action === "REFRESH_LBL_FEEDBACK_LIST") {
            setActiveFilter(prev => prev); 
        }
        else if (message.action === "SCROLL_SOURCE") {
            if (message.sourceScrollPosition) {
                document.getElementById('source-preview')?.contentWindow
                    .postMessage(
                        JSON.stringify({
                            action: "SCROLL_IFRAME",
                            scrollPosition: message.sourceScrollPosition,
                        }),
                        "*"
                    );
            }
        }
        };

        window.addEventListener("message", handleMessage);
        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, [parentHttpDomain, feedbackCategories, feedbackSeverities,feedbackCount, handleFeedbackSubmit,activeFilter]);

    return (
        <>
            <div id='container' className="dasboard-wrapper icr-wrapper">
                <BookmarkHandler projectId={projectId} parentHttpDomain={parentHttpDomain} isFinalPreviewChecked={isFinalPreviewChecked} />
                <header id="openHeader-Menu" className="header flex-center">
                    <div className='left-logo flex-center'>
                        <div className="logo-text">
                            <span>{"File Name:- " + (targetAssetMetaData?.current?.assetName ?? "")}</span>
                        </div>
                    </div>
                    <div className='right-logo flex-center relative'>
                        <button aria-label={sourcePreviewToggleButtonText} className="flex-center btn-blue-light" onClick={onSubmitClick}>
                            {"Submit"}
                        </button>
                    </div>
                </header>
                <section>
                    <div id='content' className="main-content">
                        <div className="icr-menu flex-center">
                            <div className="icr-menu-left">
                                <ul className="flex-center">
                                    <li>
                                        <div className="hide-show">
                                            <button
                                                aria-label={sourcePreviewToggleButtonText}
                                                className="flex-center btn-blue-light"
                                                onClick={toggleSourceViewHideAndShow}
                                            >
                                                {openEyeIcon}
                                                {sourcePreviewToggleButtonText}
                                            </button>
                                        </div>
                                    </li>
                                    <li className="m-hide">
                                        <div className="source flex-center">
                                            <span>Source{targetAssetMetaData.current?.srcLang ? ` - ${targetAssetMetaData.current.srcLang}` : ""}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="preview-outer">
                                            <button
                                                aria-label="preview"
                                                className={`preview flex-center ${isXLIFFOnly ? 'hide' : 'active'}`}
                                                id="preview-btn"
                                                onClick={showPreview}
                                            >
                                                Preview
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="icr-menu-right">
                                <ul className="flex-center">
                                    <li>
                                        <div className="preview-outer">
                                            <button
                                                aria-label="line by line"
                                                className={`preview flex-center ${isXLIFFOnly ? 'active' : ''}`}
                                                id="line-by-line"
                                                onClick={showLineByLineView}
                                            >
                                                Line-By-Line
                                            </button>
                                        </div>
                                    </li>
                                    <li className="m-hide">
                                        <div className="source flex-center">
                                            <span>Target{targetAssetMetaData.current?.targetLang ? ` - ${targetAssetMetaData.current.targetLang}` : ""}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div className={`final-preview flex-center ${isXLIFFOnly ? 'hide' : ''}`} id="final-preview-checkbox">
                                            <div className="form-switch flex-center">
                                                <label htmlFor="final-preview">Final Preview</label>
                                                <input
                                                    type="checkbox"
                                                    id="final-preview"
                                                    value="final preview"
                                                    className="switch"
                                                />
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            className="icr-content-inner line-text flex-center resizable-x"
                            id="preview-content"
                        >
                            <div className="icr-content-inner-left relative">
                                <div className="min-height52"></div>
                                {loading && <div className="loading-indicator">Loading content...</div>}
                                <iframe
                                    ref={sourceIframeRef}
                                    className="iframe-preview"
                                    id="source-preview"
                                    title="Source Content"
                                    srcLink={iframeSrc}
                                    allow="fullscreen"
                                    width="1000"
                                    height="1000"
                                />
                            </div>
                            <div className="splitter resizer-x">
                                <button aria-label="drag content" className="splitter-icon" tabIndex="-1">
                                    {splitterIcon}
                                </button>
                            </div>
                            <div className="icr-content-inner-right relative">
                                <h6 className="hide m-show">Target - Spanish</h6>
                                <div className="translate-content new-content relative">
                                    <div className="filter-text flex-center">
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'edit'}`}>
                                            <button
                                                aria-label="edit"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "EDITED" ? "edit-button-active flex-center" : "flex-center"}
                                                onClick={(e) => { fetchFilteredTUs("EDITED") }}
                                                aria-pressed={activeFilter === "EDITED"}
                                            >
                                                {isLoadingFilter && activeFilter === "EDITED" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="edit-count">{editedTusCount}</p>
                                                        <p className="text">Edit</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'feedback'}`}>
                                            <button
                                                aria-label="feedback"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "COMMENTED" ? "feedback-button-active flex-center" : "flex-center"}
                                                onClick={(e) => { fetchFilteredTUs("COMMENTED") }}
                                                aria-pressed={activeFilter === "COMMENTED"}
                                            >
                                                {isLoadingFilter && activeFilter === "COMMENTED" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="feedback-count">{feedbackCount}</p>
                                                        <p className="text">Feedback</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'tm'}`}>
                                            <button
                                                aria-label="tm"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "TM" ? "leveraged-button-active flex-center" : "flex-center"}
                                                onClick={(e) => { fetchFilteredTUs("TM") }}
                                                aria-pressed={activeFilter === "TM"}
                                            >
                                                {isLoadingFilter && activeFilter === "TM" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="tm-count">{leveragedTuCount}</p>
                                                        <p className="text">TM</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'locked'}`}>
                                            <button
                                                aria-label="locked"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "LOCKED" ? "locked-button-active flex-center" : "flex-center"}
                                                onClick={(e) => { fetchFilteredTUs("LOCKED") }}
                                                aria-pressed={activeFilter === "LOCKED"}
                                            >
                                                {isLoadingFilter && activeFilter === "LOCKED" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="locked-count">{lockedTuCount}</p>
                                                        <p className="text">Locked</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                        <div className={`filter-box flex-center ${isFinalPreviewChecked ? 'disabled' : 'aipe'}`}>
                                            <button
                                                aria-label="aipe"
                                                disabled={isFinalPreviewChecked || isLoadingFilter}
                                                className={activeFilter === "AIPE" ? "aipe-button-active flex-center" : "flex-center"}
                                                onClick={(e) => { fetchFilteredTUs("AIPE") }}
                                                aria-pressed={activeFilter === "AIPE"}
                                            >
                                                {isLoadingFilter && activeFilter === "AIPE" ? (
                                                    <div className="spinner-small"></div>
                                                ) : (
                                                    <>
                                                        <p className="number" id="aipe-count">{aipeTuCount}</p>
                                                        <p className="text">AIPE</p>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    {loading && <div className="loading-indicator">Loading content...</div>}
                                    <iframe
                                        ref={targetIframeRef}
                                        className="iframe-preview"
                                        id="target-preview"
                                        srcLink={iframeTarget}
                                        allow="fullscreen"
                                        width="1000"
                                        height="1000"
                                        onLoad={onLoadIFrame}
                                    />
                                    <>
                                        <EditIcr
                                            projectId={projectId}
                                            parentHttpDomain={parentHttpDomain}
                                            iframeLoaded={iframeLoaded}
                                            updateReviewStatus={handleReviewStatus}
                                            isReviewCompleted={isReviewCompleted}
                                            onCountUpdate={handleEditedTusCountUpdate}
                                        />
                                    </>
                                    <aside className="country-list icr-side-section">
                                        <ul></ul>
                                    </aside>
                                </div>
                            </div>
                        </div>
                        <LineByLine
                            isLineByLineActive={isLineByLineActive}
                            projectId={projectId}
                            editedTusCount={editedTusCount}
                            activeFilter={activeFilter}
                            onFilterChange={setActiveFilter}
                            isFinalPreviewChecked={isFinalPreviewChecked}
                            feedbackCount={feedbackCount}
                            leveragedTuCount={leveragedTuCount}
                            lockedTuCount={lockedTuCount}
                            aipeTuCount={aipeTuCount}
                            onFeedbackCountUpdate={handleFeedbackCountUpdate}
                            currentUserEmail={currentUserEmail}
                            feedbackCategories={feedbackCategories}  
                            feedbackSeverities={feedbackSeverities}  
                        />
                    </div>
                </section>
            </div>
            <ShowHistoryHandler 
  projectId={projectId} 
  parentHttpDomain={parentHttpDomain} 
  currentUserEmail={currentUserEmail}
  isAssignee={isAssignee}
  onFeedbackCountUpdate={handleFeedbackCountUpdate}
  feedbackCount={feedbackCount}
/>

            {popUpValue && <SubmitButtonPopup setPopUpValue={setPopUpValue} projectId={projectId} currentUserEmail={currentUserEmail} onFeedbackCountUpdate={handleFeedbackCountUpdate} />}
            {showSuccessNotification && (
        <SuccessNotification
          message={notificationMessage}
          onClose={() => setShowSuccessNotification(false)}
        />
      )}
        </>
    );
}

export default IcrPreview;
